import { queryJSON } from "../index";
export var hideFooterHeader = function hideFooterHeader() {
  var queryParams = queryJSON();
  return queryParams.mobile === "true";
};